import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './device_config_edit.routes';
import SaConfigService from '../../../components/api/sa_config/sa_config.service';
import ReadonlyIf from '../../../components/directive/readonly_if/readonly_if.directive';

export class DeviceConfigEditController {
  /*@ngInject*/
  constructor($stateParams, SaConfigService, $state, $mdDialog) {
    this.id = $stateParams.id;
    this.SaConfigService = SaConfigService;
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.dialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '変更しますか？',
        ok: '変更する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '変更しました',
        ok: 'OK'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      })
    };
  }

  $onInit() {
    this.SaConfigService.api.show({id: this.id},
      response => {
        this.deviceConfig = response;
      },
      err => {
        if (err.status === 404 || err.status === 403) {
          this.$state.go('main.home');
        }
      }
    );
  }

  showConfirm(deviceConfig, ev) {
    this.$mdDialog.show(this.dialog.confirm.targetEvent(ev))
      .then(() => {
        deviceConfig.base_unit_price = deviceConfig.base_unit_price || 0;
        deviceConfig.power_unit_price = deviceConfig.power_unit_price || 0;
        this.SaConfigService.api.update(
          deviceConfig,
          (okResponse) => { this.$mdDialog.show(this.dialog.success); },
          (errResponse) => { this.$mdDialog.show(this.dialog.error.content(errResponse.data.message)); }
        );
      });
  }
}

export default angular.module('leptonApp.deviceConfigEdit', [uiRouter, SaConfigService, ReadonlyIf])
  .config(routing)
  .component('deviceConfigEdit', {
    template: require('./device_config_edit.html'),
    controller: DeviceConfigEditController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/device_config/edit/device_config_edit.component.js